import { bankServices } from "../../config/axios";
import {
    BANKMASTERVIEW_SUCCESS,
    BANKMASTERVIEW_FAILED,
    RESET_BANKMASTERVIEW,
    LOADING_BANKMASTERVIEW,
    BANKMASTERVIEW_NETWORKERROR,
} from '../types/index';

const resetbankMasterView = () => {
    return { type: RESET_BANKMASTERVIEW };
};

const bankMasterView = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANKMASTERVIEW });
    await bankServices
        .post("bankmasterview", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: BANKMASTERVIEW_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: BANKMASTERVIEW_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: BANKMASTERVIEW_FAILED,
        payload: data
    };
}

export { resetbankMasterView, bankMasterView }